export type BillingNoticeState = "payment_overdue" | "payment_overdue_urgent" | "ending" | "ended";

/** German calendar date for a billing notice, in the company timezone. */
export function formatBillingGraceDate(iso: string, timeZone: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("de-DE", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: timeZone || "Europe/Berlin",
  }).format(date);
}

const CONTACT = "hallo@meisterpfad.de";

/** Notice copy for owners and admins. Billing never removes access. */
export function billingNoticeText(
  state: BillingNoticeState,
  untilIso: string | null | undefined,
  timeZone: string,
): string {
  const date = untilIso ? formatBillingGraceDate(untilIso, timeZone) : null;
  if (state === "payment_overdue") {
    return date
      ? `Eine Zahlung ist überfällig. Dein Zugang bleibt bis zum ${date} bestehen. Melde dich unter ${CONTACT}.`
      : `Eine Zahlung ist überfällig. Dein Zugang bleibt bestehen. Melde dich unter ${CONTACT}.`;
  }
  if (state === "payment_overdue_urgent") {
    return `Eine Zahlung ist überfällig. Dein Zugang bleibt bestehen. Bitte melde dich unter ${CONTACT}.`;
  }
  if (state === "ending") {
    return date
      ? `Dein Abo endet am ${date}. Melde dich unter ${CONTACT}, wenn du es verlängern willst.`
      : `Dein Abo endet zum Periodenende. Melde dich unter ${CONTACT}, wenn du es verlängern willst.`;
  }
  return date
    ? `Dein Abo ist am ${date} ausgelaufen. Dein Zugang bleibt bestehen. Melde dich unter ${CONTACT}.`
    : `Dein Abo ist ausgelaufen. Dein Zugang bleibt bestehen. Melde dich unter ${CONTACT}.`;
}
